export const initialTestimonials = [
  {
    id: "test-1",
    author: "David K. Henderson",
    role: "Chief Technology Officer",
    company: "Apex Enterprise Cloud",
    avatar: "https://images.unsplash.com/photo-1535713875002-d1d0cf377fde?auto=format&fit=crop&w=300&q=80",
    rating: 5,
    project: "Cloud Portal & Microservices Architecture",
    quote: "BuildZone's technical depth is exceptional. They restructured our backend architecture into containerized microservices, reducing API response times by 65% while keeping our team in the loop every sprint."
  },
  {
    id: "test-2",
    author: "Elena Rostova",
    role: "Head of Digital Infrastructure",
    company: "FinVault Financial",
    avatar: "https://images.unsplash.com/photo-1580489944761-15a19d654956?auto=format&fit=crop&w=300&q=80",
    rating: 5,
    project: "Corporate Treasury & Settlement Ledger",
    quote: "Finding a development partner that understands institutional financial security and real-time performance is rare. BuildZone delivered ahead of deadline and passed every third-party security audit."
  },
  {
    id: "test-3",
    author: "Dr. Rachel Sterling",
    role: "Chief Medical Officer",
    company: "MedFlow Global Health",
    avatar: "https://images.unsplash.com/photo-1573497019940-1c28c88b4f3e?auto=format&fit=crop&w=300&q=80",
    rating: 5,
    project: "HIPAA Telemedicine & EHR Suite",
    quote: "The WebRTC video platform BuildZone created transformed our clinical operations. Our doctors praise the simplicity and reliability, and patient wait times dropped by 40%."
  },
  {
    id: "test-4",
    author: "Marcus Vance",
    role: "VP of Supply Chain",
    company: "OmniStock Logistics",
    avatar: "https://images.unsplash.com/photo-1500648767791-00dcc994a43e?auto=format&fit=crop&w=300&q=80",
    rating: 5,
    project: "AI Inventory Forecasting Engine",
    quote: "Their machine learning engineers solved complex time-series forecasting challenges that other agencies struggled with. The platform paid for itself in reduced stockouts within three months."
  }
];
